import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Footer from 'shared/components/footer/Footer'
import instagram from 'shared/assets/icons/instagram.svg'
import telegram from 'shared/assets/icons/telegram.svg'
import tiktok from 'shared/assets/icons/tiktok.svg'
import './about.css'

function About({navbarHeight}) {
  const section1Ref = useRef(null);
  const [bgHeight, setBgHeight] = useState(0);

  useEffect(() => {
    if (section1Ref.current) {
      const section1Height = section1Ref.current.offsetHeight;
      setBgHeight(section1Height + navbarHeight);
    }
  }, [navbarHeight]);

  return (
    <div className='main-content'>
      <img src='./assets/images/backgrounds/bg1.png'
      className='section1-bg'
      style={{ height: `${bgHeight}px` }}
      alt="Background"/>

      <div className='about-section1' ref={section1Ref}>
        <p className="about-eyebrow">About the brand</p>
        <h1>WELCOME TO CRYPTOXNFT</h1>
        <div className='about-section-paragraphs'>
          <p className='about-section1-p1'>
            CRYPTOXNFT is a crypto-focused market community built around practical analysis, Telegram updates, VIP resources, and copy trading access. The goal is to give traders clearer context before they make their own decisions.
          </p>
        </div>
      </div>
      <div className='about-section2'>
        <p className="about-eyebrow dark">What we publish</p>
        <h1>Market context for beginners, active traders, and VIP members.</h1>
        <p>
        We cover crypto market analysis, trading setups, educational notes, and resources for people who want a more structured way to follow the market. Nothing here removes the need for personal risk control.</p>
        <p><strong>Explore the services page to compare the current VIP, copy trading, portfolio, and indicator paths.</strong></p>
        <Link to="/services"><button>SERVICES</button></Link>
      </div>
      <div className='about-section3'>
        <h1>Connect with CRYPTOXNFT</h1>
        <div className='about-section3-socials'>
          <div className='about-section3-socials-header'>
            <h2>Stay connected with us!</h2>
          </div>
          <div className='about-section3-socials-icons'>
            <a href='' target='blank'><img src={instagram} alt='instagram'/></a>
            <a href='' target='blank'><img src={telegram} alt='telegram'/></a>
            <a href='' target='blank'><img src={tiktok} alt='tiktok'/></a>
          </div>   
        </div>
        <p>Use the free Telegram group to understand the tone and value of the community before choosing any paid or verification-based path.</p>
        <p>All content is educational and informational. Trading crypto involves substantial risk, and historical examples do not guarantee future results.</p>
        <a href="https://t.me/cryptoxnfts" target="_blank" rel="noopener noreferrer">
            <button>TELEGRAM<img className='about-section3-buttin-img' src="/assets/icons/tgWhite.png"></img></button>
        </a>
      </div>
      <div className='footer'><Footer/></div>
    </div>
  );
}

export default About;
